import { useState, useEffect } from 'react';
import { PublicReportResponse } from '../types';
import { fetchPublicReport } from '../publicReportApi';

interface UsePublicReportResult {
  data: PublicReportResponse | null;
  loading: boolean;
  error: boolean;
}

export function usePublicReport(listID: string): UsePublicReportResult {
  const [data, setData] = useState<PublicReportResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    // Skip fetch if listID is empty (used when auth check is pending)
    if (!listID) {
      setLoading(false);
      return;
    }

    let isMounted = true;

    const loadReport = async () => {
      try {
        setLoading(true);
        setError(false);
        const report = await fetchPublicReport(listID);
        if (isMounted) {
          setData(report);
        }
      } catch {
        if (isMounted) {
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadReport();

    return () => {
      isMounted = false;
    };
  }, [listID]);

  return { data, loading, error };
}
